// Download function with filename client side
// No rocket science here, borrowed from:
// https://www.geeksforgeeks.org/how-to-create-and-download-csv-file-in-javascript/
export const downloadCsv = (data: string, fileName: string): void => {
    if (!fileName) {
        fileName = `${Date.now()}.csv`;
    }

    // Creating a Blob for having a csv file format
    // and passing the data with type
    const blob = new Blob([data], { type: "text/csv;charset=utf-8" });

    // Creating an object for downloading url
    const url = window.URL.createObjectURL(blob);

    // Creating an anchor(a) tag of HTML
    const a = document.createElement("a");

    // Passing the blob downloading url
    a.setAttribute("href", url);

    // Setting the anchor tag attribute for downloading
    // and passing the download file name
    a.setAttribute("download", fileName);

    // Performing a download with click
    a.click();
};
